import designerPictures from '@/constants/designer-pictures';

export default function useRadioButtonComposable()
{
    /**
     * Get the value for the `src` attribute of an `<img>` tag, given a specific
     * picture reference from CS Designer.
     *
     * @param {?string} picture The reference of the picture.
     * @returns {?string} A URL to a picture, or `null`.
     */
    function getPictureSrc(picture)
    {
        return (designerPictures[picture] ?? '') + '?ts=' + __BUILD__;
    }

    return {
        getPictureSrc,
    };
};
